!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Handle full artist description node
   */
  Drupal.behaviors.nodeArtistDescriptionFull = {

    attach: function(context) {

      // Handle back link
      // eslint-disable-next-line max-len
      $(once('nodeArtistDescriptionFullBackLink', '.node-artist-description-full .back-link', context)).each(function () {
        $(this).on('click', function() {
          let referrer = document.referrer;
          // eslint-disable-next-line max-len
          if (referrer.length > 0 && referrer.indexOf(window.location.hostname) !== -1) {
            window.location = referrer;
            return false;
          }
        });
      });

    }

  };

  // eslint-disable-next-line no-undef
})(document, Drupal, jQuery, once);
